import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { DokumentPortalowyService } from '../../../@core/http/dokument-portalowy.service';
import { KlientService } from '../../../@core/http/klient.service';
import { KontaktService } from '../../../@core/http/kontakt.service';
import { SaldeoService } from '../../../@core/http/saldeo.service';
import { WersjeJezykoweService } from '../../../@core/services/wersje-jezykowe.service';
import { Klient, KlientAlternatywny } from '../../../shared/models/klient.model';
import { Kontakt } from '../../../shared/models/kontakt.model';
import { TokenPayload } from '../../../shared/models/token-payload.model';

@Component({
  selector: 'ngx-user-account-sidebar',
  templateUrl: './user-account-sidebar.component.html',
  styleUrls: ['./user-account-sidebar.component.scss']
})
export class UserAccountSidebarComponent implements OnInit {

  @Input() isOpen = false;
  @Input() user: TokenPayload;

  @Output() onClose = new EventEmitter<void>();
  @Output() onLogout = new EventEmitter<void>();

  klient: Klient;
  kontakt: Kontakt;
  klienciAlternatywni: KlientAlternatywny[];
  maDokumentyPortalowe = false;
  availableLanguages = [
    { code: 'pl', name: 'Polski', flag: 'flag-icon-pl' },
    { code: 'en', name: 'English', flag: 'flag-icon-gb' }
  ];

  constructor(
    private router: Router,
    private toastrService: NbToastrService,
    private translate: TranslateService,
    private klientService: KlientService,
    private kontaktService: KontaktService,
    private saldeoService: SaldeoService,
    private dokumentPortalowyService: DokumentPortalowyService,
    private wersjeJezykowe: WersjeJezykoweService
  ) {}

  ngOnInit() {
    this.loadKlientData();
    this.loadKlienciAlternatywni();
    this.loadKontakt();
    this.loadDokumentyPortalowe();
  }

  loadKlientData() {
    this.klientService.getKlient().subscribe(klient => {
      this.klient = klient;
    });
  }

  loadKlienciAlternatywni() {
    this.klientService.getKlienciAlternatywni().subscribe(klienci => {
      this.klienciAlternatywni = klienci;
    });
  }

  loadKontakt() {
    this.kontaktService.getKontakt().subscribe(kontakt => {
      this.kontakt = kontakt;
    });
  }

  loadDokumentyPortalowe() {
    this.dokumentPortalowyService.getDokumenty().subscribe({
      next: dokumenty => {
        this.maDokumentyPortalowe = dokumenty.length > 0;
      },
      error: () => {
        this.maDokumentyPortalowe = false;
      },
    });
  }

  closeSidebar() {
    this.onClose.emit();
  }

  changeLanguage(langCode: string) {
    this.wersjeJezykowe.zmienJezyk(langCode);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || 'pl';
  }

  switchClient(klient: KlientAlternatywny) {
    window.location.href = `/auth/relogin/${klient.id}`;
  }

  loginToSaldeo() {
    this.saldeoService.getUrlLogowanie().subscribe({
      next: (response) => {
        if (response?.url) {
          window.open(response.url, '_blank');
        } else {
          this.toastrService.show(
            this.translate.instant('komunikat.blad.saldeo-logowanie'), 
            'Saldeo', 
            { status: 'danger' }
          );
        }
      },
      error: () => {
        this.toastrService.show(
          this.translate.instant('komunikat.blad.saldeo-logowanie'), 
          'Saldeo', 
          { status: 'danger' }
        );
      }
    });
  }

  openMessageDialog() {
    this.router.navigate(['/pages/kontakt']);
    this.closeSidebar();
  }

  openDokumentyPortalowe() {
    this.router.navigate(['/pages/dokumenty-2-plus-1']);
    this.closeSidebar();
  }

  changePassword() {
    this.router.navigate(['/pages/konto']);
    this.closeSidebar();
  }

  logout() {
    this.onLogout.emit();
  }

  getDaneKlienta(): string {
    if (!this.klient) return '';
    
    const parts = [];
    if (this.klient.nazwa) parts.push(this.klient.nazwa);
    
    return parts.join(' | ');
  }

  getNip(): string {
    return this.klient?.nip || '-';
  }

  getRegon(): string {
    return this.klient?.regon || '-';
  }
}
